/**
 * The comments screen narrowed to one article - `/comments?article=<id>` - the way an article's own
 * page goes to its comments (the owner, 2026-10-20). `CommentsInboxRoute` reads the parameter and
 * `listCommentsOnMyArticles` takes the id.
 */
export const COMMENTS_ARTICLE_PARAM = 'article';

export function commentsHrefFor(articleId: string): string {
  return `/comments?${COMMENTS_ARTICLE_PARAM}=${encodeURIComponent(articleId)}`;
}

/** The article a `/comments` address names, or undefined for all of them. */
export function commentsArticleOf(search: string): string | undefined {
  const articleId = new URLSearchParams(search).get(COMMENTS_ARTICLE_PARAM)?.trim() ?? '';
  return articleId === '' ? undefined : articleId;
}
